import { render } from "./TokoList.vue?vue&type=template&id=46270695&scoped=true"
import script from "./TokoList.vue?vue&type=script&lang=js"
export * from "./TokoList.vue?vue&type=script&lang=js"

import "./TokoList.vue?vue&type=style&index=0&id=46270695&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46270695"

export default script